import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { RootState } from "../../redux/rootReducers";
import { GetGovtOfficerJobListPayloadType } from "../../commonTypes/authTypes";
import {
  getGovtOfficerJobsListAction,
  resetAuthError,
  resetAuthSuccess,
  resetGovtOfficerJobsList,
  resetSession,
  resetTotalJobListCount,
} from "../../redux/auth";
import { connect } from "react-redux";
import { SearchIcon } from "../../components/Icon";
import { EmptyList } from "../../assets/images";
import { GovtOfficerJobsListType } from "../../redux/auth/authTypes";

import { JobProgressTable } from "../../components/AdminReports";
import { VIEW_MAPPED_JOBS_HEADERS } from "../../constant/tableHeadersConstants/govermentDirectoryConstants/govermentDirectoryHeaders";

import { JobProgressCommentType } from "../../redux/listing/listingTypes";
import {
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
} from "../../commonTypes/listing";
import {
  addJobCommentsAction,
  getAllOpenJobChecklistAction,
  getJobCommentsDetailsAction,
  getJobLinksDetailsAction,
  resetAllOpenJobChecklistData,
  resetAllOpenJobChecklistSingleData,
  resetAllOpenJobCheckTotalCount,
  resetDocumentsLinkList,
} from "../../redux/jobs";
import {
  AllOpenJobChecklistDataType,
  GetAllOpenJobCheckListPayloadType,
  JobSingleType,
} from "../../commonTypes/jobsType";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import JobClosureApproveAndSendModal from "../../components/ThinksToDo/JobClosureModule/JobClosureApproveAndSendModal";
import ChecklistModal from "../../components/JobListing/JobChecklist/ChecklistModal";
import useDebounce from "../../customHooks/useDebounce";
type AppProps = {
  token: string | null;
  dispatchGetGovtOfficerJobListAction: (
    data: GetGovtOfficerJobListPayloadType
  ) => void;
  history: any;
  allMappedJobsList: GovtOfficerJobsListType[] | [];
  totalJobListCount: number;

  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  allOpenJobChecklistData: [] | AllOpenJobChecklistDataType[];
  

  dispatchResetError: () => void;
  dispatchResetAuthSuccess: () => void;

  //   test
  dispatchResetSession: () => void;

  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => void;

  dispatchGetDocumentsLinkAction: (
    data: GetAllDocumentsLinkPayloadType
  ) => void;
  dispatchResetDocumentsLinkList: () => void;
  dispatchGetAllOpenJobCheckListData: (
    data: GetAllOpenJobCheckListPayloadType
  ) => void;
  dispatchResetAllOpenJobChecklist: () => void;
  dispathResetAllOpenJobChecklistCount: () => void;
  dispatchResetTotalJobListCount: () => void;
  dispatchResetAllMappedJobsList: () => void;
  dispatchResetAllOpenJobChecklistSingleData: () => void;

};
const ViewAllMappedJobs = ({
  token,
  dispatchGetGovtOfficerJobListAction,
  history,
  allMappedJobsList,
  totalJobListCount,
  fetching,
  success,
  error,
  statusCode,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetAuthSuccess,
  dispatchGetAllJobProgressCommentsAction,
  dispatchGetDocumentsLinkAction,
  dispatchResetDocumentsLinkList,
  dispatchGetAllOpenJobCheckListData,
  dispatchResetAllOpenJobChecklist,
  dispathResetAllOpenJobChecklistCount,
  dispatchResetTotalJobListCount,
  dispatchResetAllMappedJobsList,
  allOpenJobChecklistData,
  dispatchResetAllOpenJobChecklistSingleData,

}: AppProps) => {
  const userId = history?.location?.state?.id;
  const [jobsList, setJobsList] = useState<GovtOfficerJobsListType[] | []>([]);

  const [userOffset, setUserOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [userData, setUserData] = useState<any>([]);
  const [userSearchData, setUserSearchData] = useState<string>("");

  const [isSingleCheckListPresent, setIsSingleCheckListPresent] =
    useMenuCheck("");

  const [showProgressCommentsModal, setShowProgressCommentsModal] =
    useState<boolean>(false);
  const [jobProgressComment, setJobProgressComments] = useState<
    JobProgressCommentType[] | []
  >([]);
  const [jobsData, setJobsData] = useState<any | null>(null);
  const [showLinkUploadModal, setShowLinkUploadModal] =
    useState<boolean>(false);
  const [jobId, setJobId] = useState<string>("");
  const [modalType, setModalType] = useState<string>("");

  const [offset, setOffset] = useState(0);

  const [checkListModal, setChecklistModal] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [checklistSearchData, setChecklistSearchData] = useState<string>("");
  const [jobSingleData, setJobSingleData] = useState<JobSingleType | null>(
    null
  );
  const [showUsersWorkingOnJobData, setShowUsersWorkingOnJobData] =
      useState(null);
  const [mongoJobId, setMongoJobId] = useState<string>("");
      

  const [openJobDetailDataModal, setOpenJobDetailDataModal] =
    useState<boolean>(false);
  const [jobTypeId, setJobTypeId] = useState("");
    const [
      isAllOpenJobCheckListDetailPresent,
      setAllOpenJobCheckListDetailPresent,
    ] = useMenuCheck("");

  useEffect(() => {
    setIsSingleCheckListPresent("Single Job Checklists", "menu");
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetAuthSuccess();
    dispatchResetTotalJobListCount();
    dispatchResetAllMappedJobsList();
    dispatchResetError();
    if (userOffset > 0) {
      setUserOffset(0);
    }
  }, []);

  useEffect(() => {
    if (token && userId) {
      let finalData = {
        token,
        user_id: userId,
      };
      dispatchGetGovtOfficerJobListAction(finalData);
    }
  }, [userId]);

  useEffect(() => {
    if (allMappedJobsList?.length === 0) {
      setJobsList(allMappedJobsList);
    } else if (userOffset > 0 && jobsList?.length > 0) {
      setJobsList((prv: any) => [...prv, ...allMappedJobsList]);
    } else {
      setJobsList(allMappedJobsList);
    }
  }, [allMappedJobsList]);

  const handleChecklistSearch = (e: any) => {
    let value = e.target.value;
    setChecklistSearchData(value);
  };

  const getJobId = (data: any) => {
    setShowUsersWorkingOnJobData(data);
    setMongoJobId(data?._id);
    // // setShowUserWorkingOnJob(!showUsersWorkingOnJob);
    setOpenJobDetailDataModal(!openJobDetailDataModal);
    setJobTypeId(data?.job_id);
    setJobId(data?._id);
  };
  const handleToggleRMClosureJob = () => {
    setOpenJobDetailDataModal(!openJobDetailDataModal);
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        !fetching &&
        userOffset < +totalJobListCount &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (allMappedJobsList?.length > 0) {
          if (!fetching && userOffset < +totalJobListCount) {
            setUserOffset(userOffset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [allMappedJobsList]);

  const handleSearchUser = (e: any) => {
    setUserSearchData(e.target.value);
  };

  const handleChecklistModal = (data: any) => {
    dispatchResetAllOpenJobChecklist();
    dispathResetAllOpenJobChecklistCount();
    setChecklistModal(!checkListModal);
    setJobSingleData(data);
    if (token) {
      let finalData = {
        token,
        jobId: data.job_id,
        searchTerm,
      };
      dispatchGetAllOpenJobCheckListData(finalData);
    }
  };
  const fetchNewChecklistData = (searchData?: string) => {
    if (token && jobSingleData?.job_id) {
      let finalData = {
        token,
        jobId: jobSingleData?.job_id?.toString(),
        searchTerm: searchData ? searchData : checklistSearchData,
      };
      dispatchGetAllOpenJobCheckListData(finalData);
    }
  };

  useDebounce(
    () => {
      if (checklistSearchData) {
        fetchNewChecklistData(checklistSearchData);
      } else {
        if (jobSingleData?.job_id) {
          const finalData = {
            token,
            searchTerm: "",
            jobId: jobSingleData?.job_id?.toString(),
          };
          dispatchGetAllOpenJobCheckListData(finalData);
        }
      }
    },
    500,
    [checklistSearchData]
  );
  const handleToggleProgressCommentsModal = () => {
    setShowProgressCommentsModal(!showProgressCommentsModal);
  };

  const handleToggleLinkUploadModal = () => {
    setShowLinkUploadModal(!showLinkUploadModal);
  };

  const handleSetJobsData = (data: any, type: string) => {
    setJobProgressComments([]);
    setJobsData(data);
    setJobId(data?._id);
    setModalType(type);

    if (type === "comments") {
      let finalData: GetJobProgressCommentsPayload = {
        job_id: data?._id,
        token,
      };

      dispatchGetAllJobProgressCommentsAction(finalData);
    } else if (type === "documents") {
      dispatchResetDocumentsLinkList();
      let finalData: GetAllDocumentsLinkPayloadType = {
        job_id: data?._id,
        token,
      };

      dispatchGetDocumentsLinkAction(finalData);
    }
  }
    const handleErrorModal = () => {
      if (success === 0) {
        if (statusCode === 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!error}
              title="Error"
              message="Session Expired. Please Login Again!"
              buttonText="Logout"
              onPress={() => dispatchResetSession()}
              statusCode={statusCode}
            />
          );
        } else if (!!error && statusCode !== 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!error}
              title="Error"
              message={error}
              buttonText="OK"
              onPress={() => {
                dispatchResetError();
              }}
            />
          );
        }
      }

      return false;
    };

    return (
      <div className="row">
        {/* <div className="col-md-6">
        <CommonHeader title="Goverment Directory" />
      </div> */}
        <div className="col-md-12">
          <div className="jobs-card">
            <div className="header">
              <div className="left-header">
                <div className="heading">All Mapped Jobs</div>
                {!fetching && (
                  <div
                    className="sub-heading"
                    style={{ marginTop: "-22px" }}
                  >{`Total ${
                    totalJobListCount ? totalJobListCount : 0
                  } jobs found`}</div>
                )}
              </div>
              {/* Commented for future use */}
              {/* <div className="right-header">
                <div className={"col-md-10 position-relative"}>
                  <span
                    style={{ position: "absolute", top: "8px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    onChange={(e: any) => handleSearchUser(e)}
                    style={{ paddingLeft: "35px" }}
                    value={userSearchData}
                  />
                </div>
              </div> */}
            </div>
            <div>
              {fetching && userOffset == 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : jobsList?.length > 0 ? (
                <JobProgressTable
                  data={jobsList}
                  headers={VIEW_MAPPED_JOBS_HEADERS}
                  type={"underline"}
                  fetching={fetching}
                  handleChecklistModal={handleChecklistModal}
                  getJobId={getJobId}
                  handleSetJobsData={handleSetJobsData}
                  handleToggleProgressCommentsModal={
                    handleToggleProgressCommentsModal
                  }
                  isAdminReport={true}
                  handleToggleLinkUploadModal={handleToggleLinkUploadModal}
                  isSingleCheckListPresent={isSingleCheckListPresent}
                />
              ) : (
                <div className="mt-5 pb-5">
                  {!fetching && jobsList?.length === 0 && (
                    <EmptyListPage
                      title="No Data Found!"
                      image={EmptyList}
                      imageWidth="30%"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {openJobDetailDataModal && (
          <JobClosureApproveAndSendModal
            modal={openJobDetailDataModal}
            toggleModal={handleToggleRMClosureJob}
            jobTypeId={jobTypeId}
            jobId={jobId}
            type={"Employee"}
            history={history}
          />
        )}

              {checkListModal && (
                <ChecklistModal
                  history={history}
                  modal={checkListModal}
                  handleSearch={handleChecklistSearch}
                  setModal={setChecklistModal}
                  data={allOpenJobChecklistData}
                  fetchChecklistData={fetchNewChecklistData}
                  jobSingleData={jobSingleData}
                  dispatchResetAllOpenJobChecklistSingleData={
                    dispatchResetAllOpenJobChecklistSingleData
                  }
                  isAllOpenJobCheckListDetailPresent={
                    isAllOpenJobCheckListDetailPresent
                  }
                  checklistSearchData={checklistSearchData}
        
                />
              )}

        {handleErrorModal()}
      </div>
    );
};


const mapStateToProps = (state: RootState) => ({
  fetching: state.auth.fetching,
  success: state.auth.success,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  token: state.auth.token,
  allMappedJobsList: state.auth.govtOfficerJobsList,
  totalJobListCount: state.auth.totalJobListCount,
  allOpenJobChecklistData: state.jobs.allOpenJobChecklistData,
  
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetGovtOfficerJobListAction: (
    data: GetGovtOfficerJobListPayloadType
  ) => dispatch(getGovtOfficerJobsListAction(data)),
  dispatchResetError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => dispatch(getJobCommentsDetailsAction(data)),
  dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
    dispatch(getJobLinksDetailsAction(data)),
  dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList()),
  dispatchGetAllOpenJobCheckListData: (
    data: GetAllOpenJobCheckListPayloadType
  ) => dispatch(getAllOpenJobChecklistAction(data)),
  dispatchResetAllOpenJobChecklist: () =>
    dispatch(resetAllOpenJobChecklistData()),
  dispathResetAllOpenJobChecklistCount: () =>
    dispatch(resetAllOpenJobCheckTotalCount()),
  dispatchResetTotalJobListCount: () => dispatch(resetTotalJobListCount()),
  dispatchResetAllMappedJobsList: () => dispatch(resetGovtOfficerJobsList()),
    dispatchResetAllOpenJobChecklistSingleData: () =>
      dispatch(resetAllOpenJobChecklistSingleData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllMappedJobs);
